import { Component, inject, WritableSignal } from '@angular/core';

import { LoadingIndicatorService } from '~shared/services/loading-indicator.service';

@Component({
  selector: 'app-simple-loading-indicator',
  imports: [],
  templateUrl: './simple-loading-indicator.component.html',
})
export class SimpleLoadingIndicatorComponent {
  loadingIndicatorService = inject(LoadingIndicatorService);
  isLoading: WritableSignal<boolean> = this.loadingIndicatorService.isLoading;
  loadingURLs: WritableSignal<string[]> = this.loadingIndicatorService.requests;
}
